
import Movies from './Movies';
import Search from './Search'
import './Home.css'
import Footer from './footer';
const Home = () => {

  return (
   
      <div className='container'>
        <Search />
        <Movies />
      </div>
      

  

  )
}

export default Home;
